import { MinimalProfile } from "src/app/core/models/user/profile";

export class EditableOrganization {
  public employeeFullNameFilter: (
    employee: MinimalProfile,
    term: string,
  ) => boolean = (employee, term) =>
    employee.fullName?.toLowerCase().includes(term.toLowerCase());

  public employeeFormatter: (
    employee: MinimalProfile | null | undefined,
  ) => string = (employee) => employee?.fullName ?? '';

  public employeeCompareFn: (
    employee: MinimalProfile,
    value: MinimalProfile,
  ) => boolean = (employee, value) => employee.fullName === value.fullName;
}
